export default __webpack_public_path__ + "static/media/study-about-1.8453f9ef.png";